import React from 'react';

import Link from 'common/components/TouchpointEditor/components/TouchpointNodes/Link';
import { getEventPageContactOrganizerUrl } from 'common/components/TouchpointEditor/utils';
import {
    BRAND_LIBRARY_BUTTON_HOVER_COLOR,
    BRAND_LIBRARY_LIGHT_TEXT_COLOR,
    BRAND_LIBRARY_BUTTON_TEXT,
} from 'common/constants/brandLibrary';

export default function ContactTheOrganizer(props) {
    // eslint-disable-next-line react/prop-types
    const meta = { ...props.meta, href: getEventPageContactOrganizerUrl() };

    return <Link {...props} meta={meta} target="_blank" />;
}

ContactTheOrganizer.splash = {
    ...Link.splash,
    defaultProps: {
        ...Link.splash.defaultProps,
        meta: {
            ...Link.splash.defaultProps.meta,
            content: 'Contact the Organizer',
        },
        styles: {
            ...Link.splash.defaultProps.styles,
            fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            fontColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
        },
    },
};
